module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAALtJREFUKFNjZCAS/P//PwGotB+ICxkZGRcwEqMPqmk+ktpEYjUuAGqKR9L4Aa9GoE0FQMUSQKdVANnImnHbCFSYBNQ0F2pLJVBzB1TzAZx+hGqaDdTEhOS8NKAGkBgYYDgVh6b/QLUJQI2LsGoEagoBSqxEswlDE4qNUE3LgYIsSM7DqgmukVRNYI1ATR5AejOxNsH9CNT4AMiRJ8Z5SGrANoL8AQN/gIxk5NBDVoxLI0hTGFDTelyKkcUB0MRVtTLfaQYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/editwht.png
// module id = 1070
// module chunks = 0